import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "features/Users/types/user.types";

export const ACCESS_TOKEN_KEY = "ACCESS_TOKEN";

type UserPermission = {
  code: string;
  policies: string[];
};

interface UserState {
  user: User | null;
  permissions: UserPermission[];
  token: string | null;
  loading: boolean;
  error: any;
  isUserLogout: boolean;
}

export const initialState: UserState = {
  user: null,
  permissions: [],
  token: localStorage.getItem(ACCESS_TOKEN_KEY),
  loading: true,
  error: "",
  isUserLogout: false,
};

const loginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authLoaded(state, action) {
      state.user = action.payload.user;
      state.permissions = action.payload.permissions;
      state.loading = false;
    },

    loginSuccess(state, action) {
      state.user = action.payload.user;
      state.permissions = action.payload.permissions;
      state.token = action.payload.token;
      state.loading = false;
      state.isUserLogout = false;
    },

    logoutUserSuccess(state) {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      state.user = null;
      state.permissions = [];
      state.token = null;
      state.isUserLogout = true;
      state.loading = false;
    },

    updateAuthUser(
      state,
      action: PayloadAction<Partial<Pick<User, "firstName" | "lastName" | "avatar">>>,
    ) {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
  },
});

export const { loginSuccess, logoutUserSuccess, authLoaded, updateAuthUser } =
  loginSlice.actions;

export default loginSlice.reducer;
